import { render, staticRenderFns } from "./PackPricing.vue?vue&type=template&id=80d9cdb2&"
import script from "./PackPricing.vue?vue&type=script&lang=ts&"
export * from "./PackPricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports